import renderInlineItalic from 'lib/utils/renderInlineItalic';
import RichText from 'components/shared/richtext';
import classNames from 'classnames';
import React from 'react';
import styles from './titleAndText.module.scss';
import Button from '../../shared/button';

const TitleAndText = ({ data, locale }) => {
  const { title, titleFont, underlyingText, button, anchorId } = data;
  const titleClass = classNames(styles.title, titleFont !== 'Acumin Pro' && styles.octave);

  return (
    <section id={anchorId} className={styles.titleAndText}>
      <div className={styles.titleAndTextWrapper}>
        <h2 className={titleClass}>{renderInlineItalic(title)}</h2>
        {underlyingText?.json ? (
          <RichText
            className={styles.underlyingText}
            text={underlyingText.json}
            isPrivacyPage={data?.name === 'Privacy & Cookie Statement'}
          />
        ) : null}
        {button && (
          <Button
            className={classNames(styles.titleAndTextButton)}
            locale={locale}
            button={button}
          />
        )}
      </div>
    </section>
  );
};

export default TitleAndText;
